import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './HpRespFeaturedModuleItem.scss';

function HpRespFeaturedModuleItem({ item, onClick }) {
    return (
        <div className={classnames(styles.item, 'colXs6')}>
            <a className={styles.link} href={item.link} onClick={onClick}>
                <span className={styles.title}>{item.title}</span>
                <img className={styles.image} src={item.imageUrl} alt={item.title} />
                <span className={styles.cta}>{item.cta}</span>
            </a>
        </div>
    );
}

HpRespFeaturedModuleItem.propTypes = {
    item: PropTypes.shape({
        imageUrl: PropTypes.string,
        link: PropTypes.string,
        cta: PropTypes.string,
        title: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespFeaturedModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespFeaturedModuleItem };
